// Level-gated site pages (Companies, Opportunities…). Mirror of the backend
// utils/site_pages.py catalog. The backend is the source of truth for access;
// this maps a route path → its page key so the navbar and the route guard can
// hide/deny consistently.
//
// `access` is the shape returned by GET /api/member/site-access:
//   { enabled: bool, gated: [keys], allowed: [keys the member may view] }
// `allowed` already includes public (non-gated) pages, so a plain
// `allowed.includes(key)` is the whole rule.

export const SITE_PAGE_MATCHERS = [
  { key: 'companies', test: (p) => p === '/companies' || p.startsWith('/companies/') },
  { key: 'opportunities', test: (p) => p === '/opportunities' || p.startsWith('/opportunities/') },
  { key: 'iireport_trading_desk', test: (p) => p === '/iireport-trading-desk' },
];

// The page key that owns a given path, or null for a path we don't gate.
export function sitePageKeyForPath(pathname) {
  if (!pathname) return null;
  const p = String(pathname).split('?')[0].split('#')[0];
  for (const m of SITE_PAGE_MATCHERS) {
    if (m.test(p)) return m.key;
  }
  return null;
}

// Can the current member view this path? Defaults to TRUE whenever gating is
// off, access is unknown/not-loaded, or the path isn't a gated page — so the
// site behaves exactly as before until levels are actually configured.
export function canViewPath(pathname, access) {
  if (!access || !access.enabled) return true;
  const key = sitePageKeyForPath(pathname);
  if (!key) return true;
  return (access.allowed || []).includes(key);
}

// Same rule, keyed directly (for the route guard which knows its page key).
export function canViewPageKey(key, access) {
  if (!key) return true;
  if (!access || !access.enabled) return true;
  return (access.allowed || []).includes(key);
}
